import AppModal, { AppModalProps } from "@/common/components/Modals/AppModal";
import AppModalContent from "@/common/components/Modals/AppModalContent";
import { useModalOpenStatus } from "@/common/hooks/modal/useModalOpenStatus";
import { ViewVariant } from "@/common/ts/layout";

import VisualInspectionView, { VisualInspectionViewProps } from "./VisualInspectionView";

export interface OwnProps {
  viewProps: VisualInspectionViewProps;
}
type Props = OwnProps & AppModalProps;

export function VisualInspectionViewModal({ viewProps, ...modalProps }: Props) {
  const openStatus = useModalOpenStatus(modalProps);

  return (
    <AppModal fullWidth maxWidth='lg' {...modalProps}>
      <AppModalContent>
        {openStatus.isOpen && (
          <VisualInspectionView
            headerProps={{
              withLink: true,
              typographyProps: {
                variant: "h1",
              },
            }}
            {...viewProps}
            displayProps={{
              viewVariant: ViewVariant.Modal,
              closeInHeader: true,
              ...viewProps?.displayProps,
            }}
            onDelete={() => {
              modalProps.onClose && modalProps.onClose({}, "escapeKeyDown");
            }}
            onClose={() => {
              modalProps.onClose && modalProps.onClose({}, "backdropClick");
              viewProps.onClose && viewProps.onClose();
            }}
          />
        )}
      </AppModalContent>
    </AppModal>
  );
}
